import { Button, Chip } from "@legion-ui/core";
import { IconArrowRight } from "@tabler/icons-react";
import * as React from 'react';
export default {
  Button,
  Chip,
  IconArrowRight,
  React
};